// Keep MQTT in sync with the existing login/refresh/logout token helpers.
const TOKENKEY = 'token_key';
const listeners = new Set();
const notify = () => listeners.forEach(listener => listener());

function setToken(token) {
  localStorage.setItem(TOKENKEY, token);
  notify();
}

function getToken() {
  return localStorage.getItem(TOKENKEY);
}

function removeToken() {
  localStorage.removeItem(TOKENKEY);
  notify();
}

function subscribeToken(listener) {
  listeners.add(listener);
  const onStorage = event => {
    if (event.storageArea === localStorage && (event.key === TOKENKEY || event.key === null)) listener();
  };
  window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('storage', onStorage);
  };
}

export { setToken, getToken, removeToken, subscribeToken };
